import React from 'react'

import HSGCard from '../../../../Components/HSGCard/HSGCard'
import { HSGCardV1 } from '../../../../Components/HSGCard/HSGCard'

import { Dropdown, MenuItem } from "react-bootstrap";

import '../SmartClinic.css'
import '../Episode/Episode.css'

const episodeComplaintMeta = [
    {key: 'today', label: 'Today'},
    {key: 'week', label: 'Current Week'},
    {key: 'month', label: 'Current Month'},
    {key: 'all', label: 'Till Date'},
]

class EpisodeStats extends React.Component{

    constructor(props){
        super(props)
        this.state = {

            currentEpisodeComplaint: episodeComplaintMeta[0].key,
            currentEpisodeComplaintIndex: 0
        }
    }

    componentWillMount() {
        // this.props.fetchEpisodeStats(this.props.organizationId, episodeComplaintMeta[this.state.currentEpisodeComplaintIndex].key)
    }

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    getHeadContentDivision = (className, head, content) =>(
        <div className={className}>
            <label className="episode-block-head col-xs-12 col-sm-12 col-md-12 col-lg-12">{head}</label>
            <label className="episode-block-content col-xs-12 col-sm-12 col-md-12 col-lg-12">{ content || 'NA' }</label>
        </div>
    )

    getValueInputDivision = (className, label, input, defaultInput, index) => (
        input || defaultInput ?
        <div className={className} key = {index}>
            <label className = "hsg-sv-label">{label}</label>
            <label className = "hsg-sv-input">{`${input ? input : defaultInput}`}</label>
        </div> : null
    )

    getComplainNodesValueInputDivision = (className, labelClass, inputClass, label, input, defaultInput, index) => (
        input || defaultInput ?
        <div className={className} key = {index}>
            <label className = {`${labelClass} hsg-sv-label`}>{label}</label>
            <label className = {`${inputClass} hsg-sv-input`}>{`${input ? input : defaultInput}`}</label>
        </div> : null
    )

    getSingleValueInputHeaderDivision = (label, input) => (
        <div>
            <label className = "col-md-12 col-sm-12 col-xs-12 padding-5 hsg-sv-label center">{label}</label>
            <label className = "col-md-12 col-sm-12 col-xs-12 padding-5 hsg-sv-input center">{`${input}`}</label>
        </div>
    )

    getSingleStatsCard = (className, label, input) => (
        <div className = {className}>
            <HSGCard hideHeader>
                <div className="row">
                    {this.getSingleValueInputHeaderDivision(label, input)}
                </div>
            </HSGCard>
        </div>
    )

    _renderStatsHeader = (stats) => (
        <div style ={{marginTop: 20}}>
            {this.getSingleStatsCard("col-lg-4 col-md-6 col-sm-12 col-xs-12 padding-10", 'Till Date', stats.all_episodes)}
            {this.getSingleStatsCard("col-lg-4 col-md-6 col-sm-12 col-xs-12 padding-10", 'This Month', stats.monthly_episodes)}
            {this.getSingleStatsCard("col-lg-4 col-md-6 col-sm-12 col-xs-12 padding-10", 'This Week', stats.weekly_episodes)}
        </div>
    )

    _renderDailyReportComplainNodes = (className, complaint, header) => (
        <div className = {className}>  
            <div className="episode-block-head-v2 col-md-12 col-sm-12 col-xs-12 no-padding">
                <label className = "hsg-sv-label">{header}</label>
            </div>      
            <div className="episode-block-content col-md-12 col-sm-12 col-xs-12 no-padding">
                {
                    complaint ? complaint.map((data, index) => (
                        this.getComplainNodesValueInputDivision(
                            'col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding', 
                            'col-lg-10 col-md-10 col-sm-10 col-xs-10 no-padding episode-block-head padding-0', 
                            'col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding align-center', 
                            data.node, data.count, null, index
                        )
                    )) : 'NA'
                }
            </div>
        </div>
    )

    fetchNewStats = (index) => {
        this.setState({ currentEpisodeComplaintIndex: index })

        this.props.fetchEpisodeStats(this.props.organizationId, episodeComplaintMeta[index].key)
    }

    renderEpisodeComplaintDropdown() {
            
        return (
            episodeComplaintMeta.map((element, index) => (
                <MenuItem
                    key={index}
                    eventKey={"" + index}
                    onSelect={() => this.fetchNewStats(index)}
                >
                    {element.label}
                </MenuItem>
                )
            )
        )
    }

    getEpisodeComplaintFilters = () => (
        <Dropdown id="dropdown-select-report-year">
            <span className="hsg-dashboard-dropdown-sry-text-on-head" style={{ float: "left", color: "lightBlue" }}>
                {episodeComplaintMeta[this.state.currentEpisodeComplaintIndex].label}
            </span>

            <Dropdown.Toggle bsStyle="success" className="hsg-dashboard-dropdown-sry-toggle-on-head" />

            <Dropdown.Menu>{this.renderEpisodeComplaintDropdown()}</Dropdown.Menu>
        </Dropdown>
    )

    _renderDailyReport = (report) => (
        <HSGCardV1 headingLeft = {'Today'}>
            <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10">     
                    {/* <div className="col-md-12 col-sm-12 col-xs-12 no-padding">
                        <label className = "hsg-sv-input">{'Over All'}</label>
                    </div>          */}
                    <div className="col-md-12 col-sm-12 col-xs-12 padding-10">  
        
                        {this.getHeadContentDivision("row col-lg-6 col-md-12 col-sm-12 col-xs-12 align-center", 'Student Visited: ', report.students)}
                        {this.getHeadContentDivision("row col-lg-6 col-md-12 col-sm-12 col-xs-12 align-center", 'Episode Completed: ', report.episodes)}

                    </div>
                </div>
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10">     
                    <div className="col-md-12 col-sm-12 col-xs-12 no-padding">
                        <div className="col-md-6 col-sm-6 col-xs-6 left no-padding">
                            <label className = "hsg-sv-input left">{'Complaint Stats (Top 3)'}</label>
                        </div>
                        <div className="col-md-6 col-sm-6 col-xs-6 right no-padding">
                            <label className = "hsg-sv-input right">{this.getEpisodeComplaintFilters()}</label>
                        </div>
                    </div>         
                    <div className="col-md-12 col-sm-12 col-xs-12 no-padding">  

                        {this._renderDailyReportComplainNodes("col-lg-3 col-md-6 col-sm-12 col-xs-12 align-center", report.complaints, 'Complaints')}
                        {this._renderDailyReportComplainNodes("col-lg-4 col-md-6 col-sm-12 col-xs-12 align-center", report.symptoms, 'Sign/Symptom')}
                        {this._renderDailyReportComplainNodes("col-lg-5 col-md-6 col-sm-12 col-xs-12 align-center", report.suggestions, 'Treatment/Suggestions')}

                    </div>
                </div>
            </div>
        </HSGCardV1>
    )

    _renderStatsBody = (stats) => (
        <div>
            {this._renderDailyReport(stats)}
        </div>
    )

    render(){

        let {stats} = this.props

        return (
            <div className = "col-lg-12 col-md-12 col-sm-12 col-xs-12" style={{marginTop: 10}}>
                
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-10">
                    {stats && this._renderStatsHeader(stats)}
                </div>
                
                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 padding-10" style ={{marginTop: 5}}>
                    {stats.daily_report && this._renderStatsBody(stats.daily_report)}
                </div>

            </div>
        )
    }
}

export default EpisodeStats


// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainerV2/Component/EpisodeStats/EpisodeStats.js